

export const getTokenHeader = () => {
  const token = new URLSearchParams(location.search).get('token')
  return {
    ...!token ? {} : {
      Authorization: `Token ${ token }`,
    },
  }
}
